"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Function for going through the DataLayerSchema
 * onContainer is called whenever a nested object is hit
 * onValue is called whenver a value (string) is hit
 */
function traverseSchema(root, options) {
    function traverse(keyPath, obj) {
        Object.entries(obj).forEach(function (_a) {
            var _key = _a[0], _value = _a[1];
            var targetKeyPath = __spreadArrays(keyPath, [_key]);
            if (typeof _value === 'object') {
                if (options.onContainer) {
                    options.onContainer(targetKeyPath);
                }
                return traverse(targetKeyPath, _value);
            }
            if (options.onValue) {
                options.onValue(targetKeyPath, _value);
            }
        });
    }
    traverse([], root);
}
exports.traverseSchema = traverseSchema;
